import FavoriteList from "./../components/favorite/FavoriteList";

const Favorites = () => {
  return (
    <div className="favorite-page">
      <FavoriteList />
    </div>
  );
};

export default Favorites;
